const ADMIN_SESSION_KEY = 'chemrobotics_admin_session';
const BASE_URL = (
  process.env.REACT_APP_AUTH_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  'https://apidev.chemrobotics.com'
).replace(/\/$/, '');

const API_KEY = process.env.REACT_APP_CHEMROBOTICS_API_KEY || 'AzI0f64MzcpKE1rNmlJzTfb8PTfcdQ9y';
const PLATFORM = process.env.REACT_APP_CHEMROBOTICS_PLATFORM || 'PharmVetPat';

async function tryAdminLogin(username, password) {
  const body = new URLSearchParams({ username, password });
  const res = await fetch(`${BASE_URL}/admin/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'api-key': API_KEY,
      platform: PLATFORM,
    },
    body: body.toString(),
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok || payload?.status === false) return null;
  const data = payload?.data;
  if (!data) return null;
  const token = data.auth_token || data.token || null;
  if (!token) return null;
  const adminInfo = data.admin_info || {};
  return {
    role: 'admin',
    user: adminInfo.name || adminInfo.username || username,
    username: adminInfo.username || username,
    email: adminInfo.email || '',
    phone: adminInfo.phone || '',
    token,
    adminInfo,
  };
}

async function tryUserLogin(email, password) {
  const body = new URLSearchParams({ email, password });
  const res = await fetch(`${BASE_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'api-key': API_KEY,
      platform: PLATFORM,
    },
    body: body.toString(),
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok || payload?.status === false) {
    throw new Error(payload?.message || payload?.errors?.[0] || 'Invalid email or password.');
  }
  const userInfo = payload?.data?.user_info;
  if (!userInfo) throw new Error('Login succeeded but no user info returned.');
  const token = userInfo.auth_token || userInfo.token || null;
  if (!token) throw new Error('Login succeeded but no access token was returned.');
  return {
    role: 'admin',
    user: userInfo.name || email,
    username: userInfo.name || email,
    email: userInfo.email || email,
    phone: userInfo.mobile_no || '',
    token,
    adminInfo: userInfo,
  };
}

export async function login(emailOrUsername, password) {
  let response;
  try {
    response = await tryAdminLogin(emailOrUsername, password);
    if (!response && emailOrUsername.includes('@')) {
      response = await tryUserLogin(emailOrUsername, password);
    }
  } catch (err) {
    throw err;
  }
  if (!response) throw new Error('Invalid credentials. Please check your username and password.');
  sessionStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(response));
  return response;
}

export function logout() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}

export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(ADMIN_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function isAdminLoggedIn() {
  return !!getAdminSession()?.token;
}

export function getAdminUser() {
  return getAdminSession()?.user || null;
}

export function getAdminToken() {
  return getAdminSession()?.token || null;
}

export function getAdminHeaders() {
  const token = getAdminToken();
  return {
    'Content-Type': 'application/json',
    'api-key': API_KEY,
    platform: PLATFORM,
    ...(token ? { 'access-token': token } : {}),
  };
}
